export interface IConditionsData {
  alt: string;
  text: string;
}

export const ConditionsData = [
  { alt: 'payments', text: 'Вступительный взнос 0 рублей' },
  { alt: 'coins-bag', text: 'Инвестиции в оборудование от 475 800 рублей' },
  { alt: 'contract', text: 'Работаем по договору коммерческой концессии' },
  { alt: 'active', text: 'Окупаемость от 9 месяцев' },
  { alt: 'royalty', text: 'Роялти 20%' },
  { alt: 'return', text: 'Возможность возврата терминалов' }
];
